export const BaseCalendarScenarioId = 'CalendarBoard';
export const AgendaScenarioId = 'CalendarAsset';
export const SpacesCalendarAssetEntrySource = 'SpacesCalendarAsset';

// dynamic rendering constants
export const TodayButtonTextHideDay = 352;
export const TodayButtonTextHideAgenda = 262;
export const ShortenMonthHeader = 282;
export const HideYearHeader = 322;
export const CalendarPickerDefaultMaxWidth = 100; // default max width if for some reason component rects are undefined
export const AssetContextMenuOffset = 76; // asset context menu and margins for calendar picker max width dynamic calcs
export const HideNewEventLabel = 282;

export const MonthViewDayAgendaCalloutMaxHeight = 544;
export const MonthViewDayAgendaCalloutWidth = 380;
